/**
 * Canonical-form normalization for an email address before storing or
 * sending to a backend.
 *
 * Lowercases + trims. No format validation — that's already done at form-input
 * level via `Validators.email`. This helper exists purely to give every save
 * site a single, predictable transform so downstream lookups (Cognito user-pool
 * IDs, DynamoDB partition-key matches, case-insensitive joins) don't depend on
 * the case the admin happened to type.
 *
 * Returns '' for null / undefined / pure-whitespace input — callers can decide
 * whether to treat that as "missing" or pass an empty string through.
 */
export function normalizeEmail(value: string | null | undefined): string {
  return (value ?? '').trim().toLowerCase();
}
